import { useFormStatus } from "react-dom";
import { useClientTranslations } from "@/hooks/useClientTranslations";
import { useFocusable } from "@noriginmedia/norigin-spatial-navigation";
import { RightArrow } from "../Icons";
import { FocusKeyEnum } from "@/utils/focusKeys.helpers";

export const SendOTPButton = ({
  toggleLoginPageState,
  isValidPhoneNumber,
  onInvalid,
  className,
  buttonText,
  focusKey,
  isFocusAble = false,
  isDisabled = false,
}: {
  toggleLoginPageState: () => void;
  isValidPhoneNumber: boolean;
  onInvalid: () => void;
  className?: string;
  buttonText?: string;
  focusKey?: string;
  isFocusAble?: boolean;
  isDisabled?: boolean;
}) => {
  const { t } = useClientTranslations();
  const { pending } = useFormStatus();
  const { ref } = useFocusable({
    focusable: isFocusAble,
    focusKey: focusKey || FocusKeyEnum.SEND_OTP_BUTTON,
    onArrowPress: (direction) => {
      // Prevent focus movement when pressing left
      if (direction === "left") {
        return false;
      }
      return true;
    },
    onEnterPress: () => {
      const form = ref.current.closest("form");
      form?.requestSubmit();
      if (isValidPhoneNumber && form) {
        toggleLoginPageState();
      } else {
        onInvalid();
      }
    },
  });

  return (
    <button
      ref={ref}
      className={`relative mt-2 flex h-12 w-[100%] items-center justify-center rounded-lg bg-stg-green bg-opacity-80 px-12 text-sm font-semibold outline-none transition-all duration-200   disabled:cursor-not-allowed disabled:hover:scale-100 ${isDisabled ? "opacity-0 hover:cursor-not-allowed" : "opacity-100 hover:cursor-pointer hover:bg-opacity-80"} ${className}`}
      aria-disabled={pending}
      disabled={pending || isDisabled}
      onClick={() => {
        const form = ref.current?.closest("form");
        form?.requestSubmit();
        if (isValidPhoneNumber) {
          toggleLoginPageState();
        } else {
          onInvalid();
        }
      }}
    >
      {pending ? (
        <Loader buttonText={buttonText} />
      ) : (
        <>
          {buttonText || t("auth_screen.get_otp")}&nbsp;
          {buttonText && <RightArrow stroke="black" width={12} height={12} />}
        </>
      )}
    </button>
  );
};

const Loader = ({ buttonText }: { buttonText?: string }) => {
  return (
    <div className="flex h-6 w-full items-center justify-center gap-1.5">
      {/* Four animated dots */}
      <span
        className={`block h-1 w-1 animate-bounce rounded-full ${buttonText ? "bg-black" : "bg-white"} [animation-delay:-0.32s]`}
      ></span>
      <span
        className={`block h-1 w-1 animate-bounce rounded-full ${buttonText ? "bg-black" : "bg-white"} [animation-delay:-0.16s]`}
      ></span>
      <span
        className={`block h-1 w-1 animate-bounce rounded-full ${buttonText ? "bg-black" : "bg-white"} [animation-delay:-0.08s]`}
      ></span>
      <span
        className={`block h-1 w-1 animate-bounce rounded-full ${buttonText ? "bg-black" : "bg-white"}`}
      ></span>
    </div>
  );
};
